import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Voucher } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { Button } from '@/components/ui/button';
    import DownloadVouchers from './DownloadVouchers.vue';
    import DownloadStatements from './DownloadStatements.vue';

    interface Props {
        voucher: Voucher;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherEarlierReleasesTableActions',
  props: {
    voucher: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.voucher }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).VOUCHERS_VIEW))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.voucher.has_voucher)
              ? (_openBlock(), _createBlock(DownloadVouchers, {
                  key: 0,
                  voucher: _ctx.voucher
                }, null, 8, ["voucher"]))
              : (_ctx.voucher.has_statement)
                ? (_openBlock(), _createBlock(DownloadStatements, {
                    key: 1,
                    statement: _ctx.voucher.statement
                  }, null, 8, ["statement"]))
                : (_ctx.voucher.is_valid_no_file)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 2,
                      variant: "delete",
                      size: "xs",
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('button-text.uploaded-without-voucher')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})